import { useCallback, useState } from 'react'
import { useWeb3React } from '@web3-react/core'
import useToast from 'hooks/useToast'
import { useTranslation } from 'contexts/Localization'
import { useAppDispatch } from 'state'
import { fetchMultiPoolUserDataAsync } from 'state/multiPool'
import { withdrawMultiPool } from 'utils/calls'
import { useMultiPoolContract } from 'hooks/useContract'

const useWithdrawMultiPool = () => {
  const dispatch = useAppDispatch()
  const { toastSuccess, toastError } = useToast()
  const { t } = useTranslation()
  const { account } = useWeb3React()
  const [isWithdrawing, setIsWithdrawing] = useState(false)
  const multiPoolContract = useMultiPoolContract()

  const handleWithdrawMultiPool = useCallback(
    async (amount: string) => {
      try {
        setIsWithdrawing(true)
        const status = await withdrawMultiPool(multiPoolContract, amount)

        if (status) {
          toastSuccess(
            `${t('Withdrew')}!`,
            t('Your DMD has been withdrawn from the pool!'),
          )
          dispatch(fetchMultiPoolUserDataAsync(account))
        } else {
          toastError(
            t('Error'),
            t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
          )
        }

        setIsWithdrawing(false)
      } catch (e) {
        console.error(e)
        toastError(
          t('Error'),
          t('Please try again. Confirm the transaction and make sure you are paying enough gas!'),
        )
        setIsWithdrawing(false)
      }
    },
    [dispatch, t, toastSuccess, toastError, account, multiPoolContract],
  )

  return { handleWithdrawMultiPool, isWithdrawing }
}

export default useWithdrawMultiPool
